import { Link } from "react-router-dom";
import data from "./FooterMiddle.json";
import { useDispatch, useSelector } from "react-redux";
import {
  setExternalLink,
  setShowExternalPopup,
} from "../../../redux/slice/slicePopup";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import { cleanUrl, isExternalLink } from "../../../Utils/utils";

const FooterMiddleMenus = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: footerMiddleMenus = {}, isLoading: footerMiddleMenusLoading } =
    useGetProtectedApiDataQuery({
      url: "mastermenu-quicklinks",
      lang: languageType,
    });

  const rawMenuItems =
    footerMiddleMenus?.menu_items?.length > 0
      ? footerMiddleMenus.menu_items
      : data.menu_items || [];

  // ✅ filter active menus FIRST
  const menuItems = Array.isArray(rawMenuItems)
    ? rawMenuItems.filter((item) => item.status === true)
    : [];

  const dispatch = useDispatch();
  const handlePopupLink = (link) => {
    dispatch(setShowExternalPopup(true));
    dispatch(setExternalLink(link));
  };

  function chunk(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return [];
    const size = Math.ceil(arr.length / 3);
    let result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  }

  const formattedMenus = chunk(menuItems);

  return (
    <>
      <div className="quick-links-sec">
        {footerMiddleMenusLoading ? (
          <ul>
            <li>Loading Menus...</li>
          </ul>
        ) : menuItems.length > 0 ? (
          formattedMenus.map((menuList, index) => (
            <ul key={index}>
              {menuList.map((subMenu, i) => (
                <li key={i}>
                  {isExternalLink(subMenu.url) ? (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePopupLink(cleanUrl(subMenu.url));
                      }}
                      title={subMenu.title}
                      rel="noreferrer"
                    >
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                      {subMenu.title}
                    </a>
                  ) : (
                    <Link to={cleanUrl(subMenu.url)} title={subMenu.title}>
                      <i className="fa fa-arrow-right" aria-hidden="true"></i>
                      {subMenu.title}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          ))
        ) : (
          <ul>
            <li>No Menu Found</li>
          </ul>
        )}
      </div>
      {/* <div className="quick-links-sec">
        {formattedMenus.map((menuList, index) => (
          <ul key={index}>
            {footerMiddleMenusLoading ? (
              <li>Loading Menus...</li>
            ) : menuItems.length > 0 ? (
              menuList.map((subMenu, i) =>
                subMenu.status ? (
                  <li key={i}>
                    {isExternalLink(subMenu.url) ? (
                      <a
                        href={"#"}
                        target="_blank"
                        onClick={(e) => {
                          e.preventDefault();
                          handlePopupLink(cleanUrl(subMenu.url));
                        }}
                        title={subMenu.title}
                        rel="noreferrer"
                      >
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>

                        {subMenu.title}
                      </a>
                    ) : (
                      <Link to={cleanUrl(subMenu.url)} title={subMenu.title}>
                        <i className="fa fa-arrow-right" aria-hidden="true"></i>
                        {subMenu.title}
                      </Link>
                    )}
                  </li>
                ) : null,
              )
            ) : (
              <li>No Menu Found</li>
            )}
          </ul>
        ))}
      </div> */}
    </>
  );
};

export default FooterMiddleMenus;
